import { QueryFunctionContext } from '@tanstack/react-query'
import { DELETE, GET, POST, PUT } from '../../../redux/middleware/types'
import backendRequest from '../../../services/api/backendRequest'
import accountEndpoints from '../api/accountEndpoints'
import accountQueryKeys from '../queries/accountQueryKeys'
import { Account } from '../types/Account'
import { AccountMonthlyBudget } from '../types/AccountMonthlyBudget'

export const fetchAccounts = async ({
  queryKey: [{ companyId }],
  signal
}: QueryFunctionContext<ReturnType<(typeof accountQueryKeys)['list']>>): Promise<Account[]> => {
  if (!companyId) return []
  return backendRequest<Account[]>({
    method: GET,
    url: accountEndpoints.list(companyId),
    signal
  })
}

export const createAccount = async (data: Account, companyId: string): Promise<Account> => {
  return backendRequest<Account>({
    method: POST,
    url: accountEndpoints.list(companyId),
    data
  })
}

export const updateAccount = async (data: Account, companyId: string): Promise<Account> => {
  return backendRequest<Account>({
    method: PUT,
    url: accountEndpoints.detail(companyId, data.code),
    data
  })
}

export const deleteAccount = async (companyId: string, code: Account['code']): Promise<Account> => {
  return backendRequest<Account>({
    method: DELETE,
    url: accountEndpoints.detail(companyId, code)
  })
}

export const updateAccountBudgets = async (
  data: AccountMonthlyBudget[],
  companyId: string,
  budgetingScenarioId?: number | null,
  dimensions?: string
): Promise<void> => {
  return backendRequest<void>({
    method: PUT,
    url: accountEndpoints.budgets(companyId),
    data,
    params: {
      budgetingScenarioId,
      dimensions
    }
  })
}
